const germanExperienceLevel = new Map([
  ['Young Professional', 'Berufseinstieg'],
  ['Professional', 'Berufserfahren'],
  ['Senior', 'Senior'],
  ['Expert', 'Leitende Fachkraft'],
  ['Principal', 'Leitende Fachkraft'],
])

/** Localizes the controlled seniority vocabulary while preserving unknown CMS values. */
export function experienceLevelLabel(value: string) {
  return value
    .split('/')
    .map((part) => {
      const normalized = part.trim()
      return germanExperienceLevel.get(normalized) ?? normalized
    })
    .join(' / ')
}
